import { bootstrapWidget } from "../../common";
import CalendarWidget from "./widget";

bootstrapWidget({ widget: CalendarWidget, widgetType: "calendar" });
